type Translate = (key: string, options?: any) => string;

export function toTranslationKey(value?: string | null): string {
  if (!value) {
    return 'unknown';
  }

  const normalized = value
    .toString()
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/[\s-]+/g, '_')
    .toLowerCase();

  return normalized.replace(/_([a-z])/g, (_, char: string) => char.toUpperCase());
}

export function humanize(value?: string | null): string {
  if (!value) {
    return '';
  }

  return value
    .toString()
    .trim()
    .replace(/_/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function enumLabel(
  t: Translate,
  namespace: string,
  value?: string | null,
  fallback?: string
): string {
  const key = toTranslationKey(value);
  return t(`${namespace}.${key}`, fallback || humanize(value));
}

export function statusLabel(t: Translate, value?: string | null): string {
  return enumLabel(t, 'status', value);
}

export function vehicleTypeLabel(t: Translate, value?: string | null): string {
  return enumLabel(t, 'vehicleTypes', value);
}

export function vehicleClassLabel(t: Translate, value?: string | null): string {
  return enumLabel(t, 'vehicleClasses', value);
}

export function fuelTypeLabel(t: Translate, value?: string | null): string {
  return enumLabel(t, 'fuelTypes', value);
}

export function serviceTypeLabel(t: Translate, value?: string | null): string {
  return enumLabel(t, 'serviceTypes', value);
}

export function defectTypeLabel(t: Translate, value?: string | null): string {
  return enumLabel(t, 'defectTypes', value);
}

export function defectSeverityLabel(t: Translate, value?: string | null): string {
  return enumLabel(t, 'defectSeverities', value);
}

export function yesNoLabel(t: Translate, value: boolean): string {
  return value ? t('common.yes') : t('common.no');
}
